import { useState, useEffect } from "react";
import axios from "axios";


export function useAuth() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("jwt_token") ?? null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      if (!token) {
        setUser(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get("/api/me", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(response.data);
      } catch (error) {
        // 🔴 If backend rejects token (expired/invalid), force logout
        if (error.response && error.response.status === 401) {
          logout();
         window.location.reload();
        } else {
          setUser(null);
        }
      } finally {
        setLoading(false);
      }
    };
   
    fetchUser();
  }, [token]);

  const login = (newToken) => {
    localStorage.setItem("jwt_token", newToken);
    setToken(newToken);
  };

  const logout = () => {
    localStorage.removeItem("jwt_token");
    setToken(null);
    setUser(null);
  };

  return { user, token, loading, login, logout };
}
